function PostCont(arrElement) {

  arrElement = arrElement.map(function(index, el) {
                 if ("IMG" == jQuery(el).children().prop("nodeName")) {
                    return jQuery(el).children()[0];
                 } else {
                    return el;
                 }
               });
  return { getByClass: function (cl) {
                         return _.filter(arrElement,
                                         function(el) { 
                                           return jQuery(el).attr('class') == cl;
                                         }
                                        )[0];
                       },
           getByTag: function(tag, single) {
                       single = typeof(single) === "undefined" ? true : false;

                       var result = _.filter(arrElement,
                                       function(el) { 
                                         return jQuery(el).prop("nodeName") == tag.toUpperCase();
                                       }
                                      );
                       return single ? result[0] : result;
                     },
           getAll: function() {
                     return arrElement.slice(1);
                   },
           allContent: function() {
                         return arrElement;
           }
         };
}

module.exports = {
  reconstructPost: function(text, decode) {
    decode = decode == undefined ? true : decode;

    if (decode) {
      var decoded =  jQuery('<div/>').html(text).text();

      return new PostCont(jQuery(decoded));
    } else {
      return new PostCont(jQuery(text));
    }
  }
}